import { useEffect } from 'react';

function Redirect() {
  useEffect(() => {
    // redirect to main framer site
    window.location.replace('https://unityacademy.io');
  }, []);

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh',
      background: '#000',
      color: '#fff',
      fontSize: '1.5rem'
    }}>
      Redirecting to Unity Academy...
    </div>
  );
}

export default Redirect;